import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { StyledButton } from 'components/Buttons/Button/styles';

export const Field = styled.div`
  padding: 5px 8px;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background: ${ColorPalette.HEX.White};
  overflow: hidden;
`;

export const Label = styled.label`
  font-size: 14px;
  display: inline-block;
  color: ${ColorPalette.HEX.Manatee};
`;

export const Error = styled.span`
  font-size: 10px;
  color: ${ColorPalette.HEX.RedRYB};
`;

export const FieldContainer = styled.div`
  width: 100%;
  margin-bottom: 41px;
  padding-bottom: 20px;

  * > iframe {
    height: 100%;
    width: 100%;
  }

  &.field-error {
    padding-bottom: 0;
  }

  &.field-error ${Field} {
    border-color: ${ColorPalette.HEX.RedRYB};
  }

  &.field-error ${Label} {
    color: ${ColorPalette.HEX.RedRYB};
  }

  & input {
    color: ${ColorPalette.HEX.CharlestonGreen};
    font-size: 16px;
    line-height: 1.5em;
  }
  & input::-webkit-input-placeholder,
  & input::placeholder {
    color: ${ColorPalette.HEX.Manatee};
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const ButtonNavContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Button = styled(StyledButton)`
  &:disabled {
    background: ${ColorPalette.HEX.MetallicSilver};
  }

  &.btn-next,
  &.btn-prev {
    padding: 9px 9px 5px;
    border-radius: 21px;
    font-size: 24px;
    line-height: 1em;
    width: auto;
    height: auto;
  }
  &.btn-next .icons {
    color: ${ColorPalette.HEX.White};
  }
  &.btn-next:disabled .icons {
    color: ${ColorPalette.HEX.ChineseSilver};
  }
  &.btn-prev {
    background: ${ColorPalette.Transparent};
  }
  &.btn-prev .icons {
    color: ${ColorPalette.HEX.RedRYB};
  }
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  margin: 13px 0px;
  padding: 20px;
`;

export const StepContainer = styled.div`
  display: flex;

  & ${FieldContainer}:nth-child(1) {
    margin-right: 7px;
  }
  & ${FieldContainer}:nth-child(2) {
    margin-left: 8px;
  }
  & ${FieldContainer}:last-child {
    margin-right: 0;
  }
`;

export const Container = styled.div`
  background: ${ColorPalette.HEX.Lotion};
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media ${({ theme }) => theme.device.desktop} {
    min-height: auto;
    background: none;
  }

  &.step-1
    ${FieldContainer}.field-cvv,
    &.step-1
    ${FieldContainer}.field-first-name,
    &.step-1
    ${FieldContainer}.field-last-name,
    &.step-1
    ${FieldContainer}.field-expiration-date,
    &.step-1
    ${ButtonContainer},
    &.step-1
    ${Button}.btn-prev {
    display: none;
  }
  &.step-1 ${ButtonNavContainer} {
    justify-content: flex-end;
  }
  &.step-2
    ${FieldContainer}.field-card-number,
    &.step-2
    ${FieldContainer}.field-cvv,
    &.step-2
    ${FieldContainer}.field-expiration-date,
    &.step-2
    ${ButtonContainer} {
    display: none;
  }
  &.step-3
    ${FieldContainer}.field-card-number,
    &.step-3
    ${FieldContainer}.field-cvv,
    &.step-3
    ${FieldContainer}.field-first-name,
    &.step-3
    ${FieldContainer}.field-last-name,
    &.step-3
    ${ButtonContainer} {
    display: none;
  }
  &.step-4
    ${FieldContainer}.field-card-number,
    &.step-4
    ${FieldContainer}.field-first-name,
    &.step-4
    ${FieldContainer}.field-last-name,
    &.step-4
    ${FieldContainer}.field-expiration-date,
    &.step-4
    ${Button}.btn-next {
    display: none;
  }
`;

export const WarningContainer = styled.div`
  border-radius: 16px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  color: ${ColorPalette.HEX.CharlestonGreen};
  margin-bottom: 32px;
  background: ${ColorPalette.HEX.White};

  & img {
    margin-right: 16px;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${ColorPalette.HEX.White};
  z-index: 1;

  @media ${({ theme }) => theme.device.desktop} {
    position: absolute;
  }
`;
